function addSpeculationRules(enrollmentUrl) {
  if (
    HTMLScriptElement.supports &&
    HTMLScriptElement.supports("speculationrules")
  ) {
    const specScript = document.createElement("script");
    specScript.type = "speculationrules";
    let specRules = {
      prefetch: [
        {
          urls: [enrollmentUrl],
        },
      ],
    };

    specScript.textContent = JSON.stringify(specRules);
    document.body.append(specScript);
  }
}
